import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { Location } from '@angular/common';
import { MatToolbar, MatToolbarRow } from '@angular/material/toolbar';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { DefaultShowHideDirective } from '../../../../flex-layout/show-hide';
import { DefaultLayoutAlignDirective } from '../../../../flex-layout/custom-layout-align';
import { DefaultLayoutDirective } from '../../../../flex-layout/custom-layout';
import { DefaultFlexDirective } from '../../../../flex-layout/flex';
import { environment } from '../../../../../environments/environment';
import { UserService } from '../../../../services/user.service';
import { CartService } from '../../../../services/cart.service';
import { LoaderService } from '../../../../services/loader.service';
import { CalsoftService } from '../../../../services/calsoft.service';
import { CommonSignInComponent } from '../../../../shared/common-sign-in/common-sign-in.component';
import { LogoComponent } from '../../logo/logo/logo.component';
import { MenuComponent } from '../../menu/menu/menu/menu/menu.component';
import { CustomFlexLayoutModule } from '../../../../flex-layout/custom-flex-layout.module';
import { MobileHeader9Component } from '../mobile-header9/mobile-header9.component';


declare var $: any;


@Component({
  selector: 'calsoft-header45',
    imports: [MenuComponent, LogoComponent,CustomFlexLayoutModule, MatButtonModule, MatIcon, MatIconModule, MatToolbar, DefaultShowHideDirective, DefaultLayoutAlignDirective, MatToolbarRow, DefaultLayoutDirective, DefaultFlexDirective, LogoComponent, forwardRef(() => MenuComponent),MobileHeader9Component],
  templateUrl: './header45.component.html',
  styleUrl: './header45.component.scss'
})
export class Header45Component implements OnInit {

  public serverPath = environment.commonImageApi + "logo/";
  @Input() languageSelection: any;
  @Input() data: any;
  toggleActive: boolean = false;
  cartProducts: any;
  popupResponse: any;
  wishlistProducts: any;
  userLoggedIn: boolean | any;
  page: any;
  page1: any;
  cartTotalItems: any;
  public form!: UntypedFormGroup;
  url: any;
  index: any;
  @Input() item: any;
  display: boolean| any ;
  mobileHeaderType: any = 0;
  displaySearchBar: boolean = false;
  countryCode!: Subject<any>;

  constructor(public calsoftService: CalsoftService,

    private router: Router,
    private basicAuthenticationService: UserService,
    private dialog: MatDialog,
    private userService: UserService,
    public cartServices: CartService,
    private loaderService: LoaderService,
    private location: Location

  ) { }

  hidePage: boolean = false;
  excludedUrls: string[] = [
    // '/marketing',
    // '/software-product-developments',
    // '/Software-Architecture-Developments',
    // '/mobile-application-developments',
    // '/saas-application-developments'
  ];

  ngOnInit() {
    console.log("the item data is ",this.item);
    

     this.countryCode = this.loaderService.countryCode;

    this.userLogged();
    this.url = this.router.url;

    if (window.innerWidth < 1281) {
      this.display = false;
    } else {
      this.display = true
    }
    this.mobileHeaderType = this.data['mobileHeaderType'];

    // let currentUrl = this.router.url;
    // this.hidePage = this.excludedUrls.includes(currentUrl);

    if (this.url === '/blog') {
      this.hidePage = true;
    } else if (this.url.startsWith('/blog/')) {
      this.hidePage = true;
    } 
    else if (this.url.includes('/product/')){
      this.hidePage= true;
    }
      else {
      this.hidePage = false;
    }

  }


  userLogged() {

    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };

    let basicAuthHeaderString = this.basicAuthenticationService.getAuthenticatedToken();
    let username = this.basicAuthenticationService.getAuthenticatedUser();

    if (basicAuthHeaderString && username) {

      this.userLoggedIn = true;
      this.cartServices.getCount();

    }
    else {

      this.userLoggedIn = false;
    }
  }




  loginModel() {
    // if (window.innerWidth > 768) {

    //   let dialogRef = this.dialog.open(CommonSignInComponent, {
    //     width: '790px',
    //     data: { page: this.page1, }
    //   });

    //   dialogRef.disableClose = true;
    //   dialogRef.afterClosed().subscribe(result => {
    //     this.ngOnInit();


    //   });

    // }
    // else {
    //   let dialogRef = this.dialog.open(CommonSignInComponent, {
    //     minWidth: '100vw', height: '100vh',
    //     data: { page: this.page1, }
    //   });

    //   dialogRef.disableClose = true;
    //   dialogRef.afterClosed().subscribe(result => {
    //     this.ngOnInit();


    //   });
    // }

  }

  back() {
    this.location.back();
  }


  cart() {
    let basicAuthHeaderString = this.userService.getAuthenticatedToken();
    let username = this.userService.getAuthenticatedUser();

    if (basicAuthHeaderString && username) {
      this.router.navigate(['/cart'])

    }
    else {
      this.page1 = "cart";
      this.loginModel();

      // this.router.navigate(['/cart'])

    }

  }

  wishlist() {
    this.router.navigate(['/account/wishlist']);
  }

  SignIn() {
    // this.router.navigate(['/sign-in']);
    this.loginModel();
  }

  home() {
    this.router.navigate(['/'])
  }


  search() {
    this.router.navigate(['/search'])
  }

  public toggleSearch() {
    $('app-main').toggleClass('form-open');
  }

  public toggleSidebar() {
    this.calsoftService.sidenavOpen = !this.calsoftService.sidenavOpen;
  }



  public selectedCurrency(value: any) {
    this.calsoftService.currency = value;
  }

  public selectedLanguage(value: any) {
    this.calsoftService.language = value;
  }

  hideSearch() {
    this.displaySearchBar = false;
  }

  showSearchBar() {
    this.displaySearchBar = true;
  }

  callPhone() {
    let phoneNumber = "tel:" + this.data.storePhoneNumber;
    window.location.href = phoneNumber;
  }

}


